import React from 'react';
import PropTypes from 'prop-types';
import Image from './Image';

const ImageWithUrls = ({
  imageUrls, alt, width, height, sizes, cacheKey, objectFit, ...rest
}) => (
  <Image
    placeholder={imageUrls[0]}
    src={imageUrls[1]}
    alt={alt}
    width={width}
    height={height}
    objectFit={objectFit}
    sizes={sizes}
    cacheKey={cacheKey}
    {...rest}
  />
);

ImageWithUrls.propTypes = {
  alt: PropTypes.string.isRequired,
  imageUrls: PropTypes.arrayOf(PropTypes.string).isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  sizes: PropTypes.string.isRequired,
  cacheKey: PropTypes.string,
  objectFit: PropTypes.string,
};

ImageWithUrls.defaultProps = {
  width: '100%',
  height: 'auto',
  objectFit: 'cover',
  cacheKey: '',
};

export default ImageWithUrls;
